import Cookies from 'js-cookie';

const isDevelopment = process.env.NODE_ENV === 'development';
const protocol = Cookies.get('serviceId') === 'iamstudent' ? 'iamstudentapp' : (Cookies.get('serviceId') === 'iamteacher' ? 'iamteacherapp' : 'iamschoolparentapp');

export const schema = (schema, url) => {
    callScheme(`${schema}://${url}`);
};

export const toast = (schema, message) => {
    callScheme(`${schema}://toast?message=${encodeURIComponent(message)}`);
};

export function getWebviewUrl({url, landingtype, webviewtype}) {
    return `${protocol}://webview?landingtype=${landingtype}&webviewtype=${webviewtype}&url=${url}`;
};

function callScheme(url) {
    if (isDevelopment) {
        console.info(url);
    }

    let iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('height', '1px');
    iframe.setAttribute('width', '1px');
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
}
